import {nsDynamicVariable} from "../../dynamic-variable/nsDynamicVariable";

export namespace nsMapping {

    export const parseExpression = (expression: string): IExpressionTransformMapping => {
        const args = nsDynamicVariable.getArguments(expression).map(o => o.str);
        const subject = args[1] ?? '';
        const mappings = args
            .slice(2) // [...;...;<-- these -->]
            .map(s => s.split('|'))
            .map(item => ({source: item[0] ?? '', destination: item[1] ?? ''}))
        ;
        return {subject, mappings};
    }

}